import { CSSRenderer } from './CSSRenderer';
import { AuthenticatedFlow, AuthenticatedOCPlus } from './../RoutingFlow/FlowComponentsConstants';

export function renderBrandStyle(dealershipSummary, vFlowSource, vThemeMake, vMake) {
    const brand = dealershipSummary.brands;
    // If authenticated Flow and No theme
    if ((vFlowSource === AuthenticatedFlow || vFlowSource === AuthenticatedOCPlus) && !vThemeMake && vMake) {
        CSSRenderer(vMake);
    } else if (
        vThemeMake === '' &&
        brand &&
        brand.length === 1 &&
        (vFlowSource !== AuthenticatedFlow || vFlowSource !== AuthenticatedOCPlus)
    ) {
        // if the vThemeMake ='' , not Authenticatedflow, and brand === 1 call cssRender(brand)
        let brandTheme = brand[0];
        brandTheme = brandTheme[0].toUpperCase() + brandTheme.slice(1).toLowerCase();

        CSSRenderer(brandTheme);
    } else {
        CSSRenderer(vThemeMake);
    }
}
